import React from 'react';
import ReactEcharts from 'echarts-for-react';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import { useTheme } from '../../../../theme-context';

interface IBarChart {
    xAxisData: Array<string | number>;
    chartData: Array<number>;
    showRotate?: boolean;
}

const BarChart = ({ xAxisData, chartData, showRotate }: IBarChart) => {
    const { theme } = useTheme();
    const getOptionBar = () => ({
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params: any) {
                const item = params[0];
                return `
                    <strong>${item.name}</strong><br />
                    Value: ${item.value}
                `;
            }
        },
        xAxis: {
            type: 'category',
            data: xAxisData,
            axisLabel: {
                // interval: 0,
                rotate: showRotate && 30,
                formatter: function (value: string) {
                    return value.length > 10 ? value.slice(0, 10) + '…' : value;
                }
            }
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                data: chartData,
                type: 'bar',
                color: theme === 'dark' ? '#f59e0b' : '#252B37'
            }
        ]
    })
    return (
        <div>
            <ReactEcharts option={getOptionBar()} style={{ height: 400, width: '100%' }} />
        </div>
    )
}
export default BarChart;